// iter20.9 (2026-05-19): locale-aware wishlist routes.
// wlLocalePrefix() reads from window.location.pathname so the wishlist header
// icon, empty-state CTA, and cart-icon-locator selector all stay on the
// active locale (EN at /en/, EL at root). Same pattern as mnLocalePrefix()
// in mobile-luxury.js (iter20.6).
function wlLocalePrefix() {
  var m = (window.location.pathname || '').match(/^\/([a-z]{2})(?:\/|$)/);
  return m ? '/' + m[1] : '';
}

const WL = {
  KEY: 'mensedit_wishlist',
  get() {
    try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); } catch { return []; }
  },
  save(items) {
    localStorage.setItem(this.KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('wishlist:change'));
  },
  has(id) { return this.get().some(i => String(i.id) === String(id)); },
  toggle(p) {
    const items = this.get();
    const idx = items.findIndex(i => String(i.id) === String(p.id));
    if (idx > -1) { items.splice(idx, 1); this.save(items); return false; }
    items.unshift(p); this.save(items); return true;
  },
  remove(id) { this.save(this.get().filter(i => String(i.id) !== String(id))); },
  count() { return this.get().length; }
};

function syncUI() {
  const count = WL.count();
  document.querySelectorAll('[data-wl-count]').forEach(el => {
    el.textContent = count;
    el.hidden = count === 0;
  });
  document.querySelectorAll('[data-wl-toggle]').forEach(btn => {
    const id = btn.dataset.wlId;
    const active = WL.has(id);
    btn.classList.toggle('wl-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
}

function injectHeaderIcon() {
  // v2.17: Liquid-rendered v2.13 icon (header-actions.liquid) is canonical now.
  // Skip JS injection if it's already present to avoid a duplicate star.
  if (document.querySelector('.header-actions__wishlist-icon')) return;
  if (document.getElementById('wl-header-link')) return;
  // iter20.9: locate the cart link by href-suffix so the selector works on
  // both /cart (root locale) and /en/cart (EN locale).
  const cartLink = document.querySelector('a[href$="/cart"]');
  if (!cartLink) return;
  const prefix = wlLocalePrefix();
  const a = document.createElement('a');
  a.id = 'wl-header-link';
  a.href = prefix + '/pages/wishlist';
  a.className = 'wl-header-link';
  a.setAttribute('aria-label', 'Wishlist');
  a.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" width="22" height="22">' +
    '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>' +
    '</svg>' +
    '<span class="wl-badge" data-wl-count hidden>0</span>';
  cartLink.parentNode.insertBefore(a, cartLink);
  syncUI();
}

function injectCardHearts() {
  document.querySelectorAll('template.wl-data').forEach(tpl => {
    if (tpl._wlProcessed) return;
    tpl._wlProcessed = true;

    const span = tpl.content.querySelector('[data-id]');
    if (!span) return;
    const id = span.dataset.id;

    /*
      DOM layout on this theme:
        <product-card>          <- custom element
          <div class="card-gallery">  <- image wrapper
            <a class="contents">..images..</a>
          </div>
          ...info...
        </product-card>
        <template class="wl-data">  <- sibling, NOT child

      Walk backward from the template to find its product-card sibling,
      then descend into the image wrapper.
    */
    let card = tpl.previousElementSibling;
    while (card && card.tagName.toLowerCase() !== 'product-card') {
      card = card.previousElementSibling;
    }

    // Fallback: check parentElement for older card layouts
    if (!card) {
      card = tpl.parentElement;
    }
    if (!card) return;

    // Target the image gallery div — handles both this theme and classic Horizon
    const imgWrap = card.querySelector(
      '.card-gallery, [ref="cardGallery"], .card__media, .card-media'
    );
    if (!imgWrap) return;

    if (imgWrap.querySelector('.wl-card-btn')) return;

    if (getComputedStyle(imgWrap).position === 'static') {
      imgWrap.style.position = 'relative';
    }

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wl-card-btn' + (WL.has(id) ? ' wl-active' : '');
    btn.dataset.wlToggle = '';
    btn.dataset.wlId     = id;
    btn.dataset.wlHandle = span.dataset.handle;
    btn.dataset.wlTitle  = span.dataset.title;
    btn.dataset.wlImage  = span.dataset.image;
    btn.dataset.wlUrl    = span.dataset.url;
    btn.dataset.wlPrice  = span.dataset.price;
    btn.dataset.wlVendor = span.dataset.vendor;
    btn.setAttribute('aria-label', 'Save to wishlist');
    btn.setAttribute('aria-pressed', WL.has(id) ? 'true' : 'false');
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">' +
      '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>' +
      '</svg>';

    imgWrap.appendChild(btn);
  });
}

// Re-run when new cards arrive (infinite scroll / AJAX pagination)
(function() {
  if (!('MutationObserver' in window)) return;
  var timer;
  var root = document.getElementById('MainContent') || document.body;
  new MutationObserver(function() {
    clearTimeout(timer);
    timer = setTimeout(injectCardHearts, 150);
  }).observe(root, { childList: true, subtree: true });
}());

document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-wl-toggle]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  var p = {
    id:     btn.dataset.wlId,
    handle: btn.dataset.wlHandle,
    title:  btn.dataset.wlTitle,
    image:  btn.dataset.wlImage,
    url:    btn.dataset.wlUrl,
    price:  btn.dataset.wlPrice,
    vendor: btn.dataset.wlVendor
  };
  WL.toggle(p);
  syncUI();
});

function renderWishlistPage() {
  var container = document.getElementById('wl-page');
  if (!container) return;
  var items = WL.get();
  if (items.length === 0) {
    // iter20.9: prefix the empty-state CTA with the current locale.
    var prefix = wlLocalePrefix();
    container.innerHTML =
      '<div class="wl-empty">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48">' +
      '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>' +
      '</svg>' +
      '<p>Your wishlist is empty.</p>' +
      '<a href="' + prefix + '/collections/all" class="button">Explore Products</a>' +
      '</div>';
    return;
  }
  container.innerHTML = '<div class="wl-grid">' + items.map(function(item) {
    return '<div class="wl-item">' +
      '<a href="' + item.url + '" class="wl-item__img-wrap">' +
        '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
      '</a>' +
      '<div class="wl-item__info">' +
        '<span class="wl-item__vendor">' + item.vendor + '</span>' +
        '<a href="' + item.url + '" class="wl-item__title">' + item.title + '</a>' +
        '<span class="wl-item__price">' + item.price + '</span>' +
      '</div>' +
      '<button class="wl-item__remove" aria-label="Remove from wishlist" data-wl-remove="' + item.id + '">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16">' +
        '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>' +
        '</svg>' +
      '</button>' +
    '</div>';
  }).join('') + '</div>';
  container.querySelectorAll('[data-wl-remove]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      WL.remove(btn.dataset.wlRemove);
      renderWishlistPage();
      syncUI();
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  injectHeaderIcon();
  injectCardHearts();
  renderWishlistPage();
  syncUI();
});

window.addEventListener('wishlist:change', function() {
  syncUI();
  renderWishlistPage();
});
